<div class="container-fluid glb-popup">
  <h2>{{ formTitle }}</h2>
  <p-toast [style]="{ marginTop: '80px' }"> </p-toast>
  <span style="float: right; top: -50px; background-color: transparent"><app-help-link [helpName]="'msgCampaign'" [formReadOnly]="true"></app-help-link></span>
  <button
    mat-icon-button
    [mat-dialog-close]="true"
    style="float: right; top: -50px; background-color: transparent"
    >
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr />
  <div [formGroup]="form1" class="forms w-100 d-block">
    <div class="row m-0">
      <div class="col-lg-12">
        @if (formAlert) {
          <div class="w-100 mb-3">
          <div class="w-100" style="
              text-align: center;
              background-color: yellow;
              padding: 5px;
              margin-bottom: 15px;
            ">
              <p>
                <b>{{ formAlert }}</b>
              </p>
            </div>
          </div>
        }
      </div>
      <div class="col-lg-12" style="background-color: #69cee7; margin-bottom: 15px">
        <span><b> Message Count:</b> </span> @for (state of msgCountList; track state) {
        <span> {{state?.status}} : {{state?.count}}</span>
        } <span style="margin-left: 10px"><i class="pi pi-refresh" (click)="fetchMsgCount()"></i> </span>
      </div>

      <div class="col-lg-4">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="name" id="name" type="text" pInputText/>
          <label for="name">Campaign Name</label>

          @for (validation of validationMessages.name; track validation) {
            <span>
              @if (form1.get('name').hasError(validation.type) && (form1.get('name').dirty || form1.get('name').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-4">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="type" id="type" type="text" pInputText/>
          <label for="name">Campaign Type</label>

          @for (validation of validationMessages.name; track validation) {
            <span>
              @if (form1.get('type').hasError(validation.type) && (form1.get('type').dirty || form1.get('type').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-2">
        <span class="p-float-label w-100 mb-3">
          <p-dropdown class="w-100" [options]="statuses" formControlName="status" optionLabel="name" optionValue="value"
          placeholder="status"></p-dropdown>
          <label for="status">Status</label>
          @for (validation of validationMessages.status; track validation) {
            <span>
              @if (form1.get('status').hasError(validation.type) && (form1.get('status').dirty || form1.get('status').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-2">
        <span class="p-float-label w-100 mb-3">
          <p-calendar formControlName="sendOnDate" inputId="sendOnDate" appendTo="body">
          </p-calendar>
          <label for="sendOnDate">Send On Date</label>
          @for (validation of validationMessages.sendOnDate; track validation) {
            <span>
              @if (
                (form1.get('sendOnDate').hasError(validation.type) &&
                form1.get('sendOnDate').dirty) ||
                form1.get('sendOnDate').touched) {
                <small class="p-invalid">{{ validation.message }}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-12">
        <span class="p-float-label required-field w-100 mb-3">
          <textarea formControlName="description" name="description"
          rows="1" cols="30" pInputTextarea></textarea>
          <label for="description">Description</label>
          @for (validation of validationMessages.description; track validation) {
            <span>
              @if ((form1.get('description').hasError(validation.type) &&
                form1.get('description').dirty) ||
                form1.get('description').touched) {
                <small class="p-invalid">{{ validation.message }}</small>
              }</span>
            }
          </span>
        </div>


        <hr>
          <div class="col-lg-12">
            <div class="flex align-items-center">
              <!-- <p-checkbox [formControl]="form1.controls['sendByEmail']" inputId="sendByEmail" [binary]="true"></p-checkbox> -->
              <span class="employeeProfile-nm"><strong>Send By Email</strong></span>
            </div>
            <!-- <span *ngFor="let validation of validationMessages.sendByEmail">
          <small class="p-invalid" *ngIf="
              (form1.get('sendByEmail').hasError(validation.type) &&
                form1.get('sendByEmail').dirty) ||
              form1.get('sendByEmail').touched
            ">{{ validation.message }}
            </small>
          </span> -->
        </div>
        <hr>


          <div class="col-lg-6">
            <span class="p-float-label required-field w-100 mb-3">
              <input formControlName="senderName" id="senderName" type="text" pInputText/>
              <label for="senderName">Sender Name</label>

              @for (validation of validationMessages.senderName; track validation) {
                <span>
                  @if (form1.get('senderName').hasError(validation.type) && (form1.get('senderName').dirty || form1.get('senderName').touched)) {
                    <small class="p-invalid"
                      >{{validation.message}}
                    </small>
                  }
                </span>
              }
            </span>
          </div>




          <div class="col-lg-6">
            <span class="p-float-label required-field w-100 mb-3">
              <input formControlName="senderEmail" id="senderEmail" type="text" pInputText/>
              <label for="name">Sender Email</label>

              @for (validation of validationMessages.senderEmail; track validation) {
                <span>
                  @if (form1.get('senderEmail').hasError(validation.type) && (form1.get('name').dirty || form1.get('senderEmail').touched)) {
                    <small class="p-invalid"
                      >{{validation.message}}
                    </small>
                  }
                </span>
              }
            </span>
          </div>
          <div class="col-lg-12">
            <span class="p-float-label w-100 mb-3">
              <p-dropdown class="w-100" [options]="msgTemplates" formControlName="msgTemplateId" optionLabel="searchLabel"
                placeholder="Template" [filter]="true" filterBy="searchLabel"
                filterPlaceholder="Search by name or ID..."
              (onChange)="selectTemplate($event)">
                <ng-template pTemplate="item" let-item>
                  <span>#{{item.msgTemplateId}} — {{item.name}}</span>
                </ng-template>
                <ng-template pTemplate="selectedItem" let-item>
                  <span>#{{item.msgTemplateId}} — {{item.name}}</span>
                </ng-template>
              </p-dropdown>
              <label for="msgTemplateId">Select Template</label>
            </span>
          </div>
          <div class="col-lg-6">
            <span class="p-float-label required-field w-100 mb-3">
              <input formControlName="subject" id="subject" type="text" pInputText/>
              <label for="subject">Subject</label>

              @for (validation of validationMessages.subject; track validation) {
                <span>
                  @if (form1.get('subject').hasError(validation.type) && (form1.get('subject').dirty || form1.get('subject').touched)) {
                    <small class="p-invalid"
                      >{{validation.message}}
                    </small>
                  }
                </span>
              }
            </span>
          </div>

          <div class="col-lg-6">
            <span class="p-float-label required-field w-100 mb-3">
              <input formControlName="preHeader" id="preHeader" type="text" pInputText/>
              <label for="preHeader">Pre Header</label>@for (validation of validationMessages.preHeader; track validation) {
              <span>
                @if (
                  (form1.get('preHeader').hasError(validation.type) &&
                  form1.get('preHeader').dirty) ||
                  form1.get('preHeader').touched) {
                  <small class="p-invalid">{{ validation.message }}</small>
                }</span>
              }
            </span>
          </div>
          <div class="col-lg-12">
            <span class="p-float-label w-100 mb-3">
              <p-fileUpload name="files[]" [chooseIcon]="'pi pi-paperclip'" (onSelect)="myUploader($event)" [auto]="true"
                fileLimit="5"
                multiple="multiple" accept=".jpg,.jpeg,.gif,.pdf,.xls,.xlsx" maxFileSize="52428800">
                <ng-template pTemplate="content">
                  @if (uploadedFiles.length) {
                    <ul>
                      @for (file of uploadedFiles; track file) {
                        <li>{{file.name}} - {{file.size}} bytes
                        </li>
                      }
                    </ul>
                  }
                </ng-template>
              </p-fileUpload>
            </span>
          </div>
          <div class="col-lg-12">
            <label for="emailHtml">Email Html</label>
            <span class="p-float-label required-field w-100 mb-3">
          <editor formControlName="emailHtml" id="emailHtml" [init]="tinyMceInit">
              </editor>
              @for (validation of validationMessages.emailHtml; track validation) {
                <span>
                  @if (form1.get('emailHtml').hasError(validation.type) && (form1.get('emailHtml').dirty || form1.get('emailHtml').touched)) {
                    <small class="p-invalid"
                      >{{validation.message}}
                    </small>
                  }
                </span>
              }
            </span>
            All variables listed at help document:<app-help-link [helpName]="'msgCampaign'" [formReadOnly]="true"></app-help-link>
          </div>

          <div class="col-lg-12">
            <span class="p-float-label required-field w-100 mb-3"
              ><textarea
              formControlName="emailText"
              id="emailText"
              style="height: 300px"
              type="text"
              pInputText
            ></textarea><label for="emailText">Email Text</label
            >@for (validation of validationMessages.emailText; track validation) {
            <span
              >@if (
              (form1.get('emailText').hasError(validation.type) &&
              form1.get('emailText').dirty) ||
              form1.get('emailText').touched) {
              <small
                class="p-invalid"
                >{{ validation.message }}</small
                >
                }</span
                >
                }</span
                >
              </div>
              <hr>
                <div class="col-lg-12">
                  <div class="flex align-items-center">
                    <!-- <p-checkbox
                    [formControl]="form1.controls['sendBySms']"
                    inputId="sendBySms"
                    [binary]="true"
                  ></p-checkbox> -->
                  <span class="employeeProfile-nm"><strong>Send By SMS</strong></span>
                </div>
                <!-- <span *ngFor="let validation of validationMessages.sendBySms">
                <small
                  class="p-invalid"
            *ngIf="
              (form1.get('sendBySms').hasError(validation.type) &&
                form1.get('sendBySms').dirty) ||
              form1.get('sendBySms').touched
            "
                  >{{ validation.message }}
                </small>
              </span> -->
            </div>
            <hr>
              <div class="col-lg-3">
                <span class="p-float-label required-field w-100 mb-3">
                  <p-dropdown class="w-100" [options]="countries" formControlName="senderCountryCode" optionLabel="name"
                  optionValue="dial" placeholder="Country Code"></p-dropdown>
                  <label for="senderCountryCode">Sender Country</label>
                  @for (validation of validationMessages.senderCountryCode; track validation) {
                    <span>
                      @if (form1.get('senderCountryCode').hasError(validation.type) && (form1.get('senderCountryCode').dirty || form1.get('senderCountryCode').touched)) {
                        <small class="p-invalid"
                          >{{validation.message}}
                        </small>
                      }
                    </span>
                  }
                </span>
              </div>
              <div class="col-lg-3">
                <span class="p-float-label required-field w-100 mb-3">
                  <!-- <p-inputMask formControlName="senderMobileNum" id="senderMobileNum" mask="(999) 999-9999" type="text">
                </p-inputMask> -->
                <input formControlName="senderMobileNum" id="senderMobileNum" type="text" pInputText>
                <label for="senderMobileNum">Sender Mobile Number</label>
                @for (validation of validationMessages.senderMobileNum; track validation) {
                  <span>
                    @if (form1.get('senderMobileNum').hasError(validation.type) && (form1.get('senderMobileNum').dirty || form1.get('senderMobileNum').touched)) {
                      <small class="p-invalid"
                        >{{validation.message}}
                      </small>
                    }
                  </span>
                }
              </span>
            </div>

            <div class="col-lg-6">
              <span class="p-float-label required-field w-100 mb-3"
                ><input
                formControlName="headers"
                id="headers"
                type="text"
                pInputText
                /><label for="headers">Headers</label
                >@for (validation of validationMessages.headers; track validation) {
                <span
                  >@if (
                  (form1.get('headers').hasError(validation.type) &&
                  form1.get('headers').dirty) ||
                  form1.get('headers').touched) {
                  <small
                    class="p-invalid"
                    >{{ validation.message }}</small
                    >
                    }</span
                    >
                    }</span
                    >
                  </div>

                  <div class="col-lg-12">
                    <span class="p-float-label required-field w-100 mb-3"
                      >
                      <textarea formControlName="mobileText" name="mobileText"
                      rows="1" cols="30" pInputTextarea></textarea>
                      <label for="mobileText">Mobile Text</label
                        >@for (validation of validationMessages.mobileText; track validation) {
                        <span
                          >@if (
                          (form1.get('mobileText').hasError(validation.type) &&
                          form1.get('mobileText').dirty) ||
                          form1.get('mobileText').touched) {
                          <small
                            class="p-invalid"
                            >{{ validation.message }}</small
                            >
                            }</span
                            >
                            }</span
                            >
                          </div>



                          <div class="col-lg-6">
                            <span class="p-float-label required-field w-100 mb-3"
                              ><input
                              formControlName="statusMsg"
                              id="statusMsg"
                              type="text"
                              pInputText
                              /><label for="statusMsg">Status Msg</label
                              >@for (validation of validationMessages.statusMsg; track validation) {
                              <span
                                >@if (
                                (form1.get('statusMsg').hasError(validation.type) &&
                                form1.get('statusMsg').dirty) ||
                                form1.get('statusMsg').touched) {
                                <small
                                  class="p-invalid"
                                  >{{ validation.message }}</small
                                  >
                                  }</span
                                  >
                                  }</span
                                  >
                                </div>

                                <div class="col-lg-6">
                                  <span class="p-float-label required-field w-100 mb-3"
                                    ><input
                                    formControlName="confId"
                                    id="confId"
                                    type="text"
                                    pInputText
                                    /><label for="confId">ConfId</label
                                    >@for (validation of validationMessages.confId; track validation) {
                                    <span
                                      >@if (
                                      (form1.get('confId').hasError(validation.type) &&
                                      form1.get('confId').dirty) ||
                                      form1.get('confId').touched) {
                                      <small
                                        class="p-invalid"
                                        >{{ validation.message }}</small
                                        >
                                        }</span
                                        >
                                        }</span
                                        >
                                      </div>

                                      <div class="col-lg-6">
                                        <span class="p-float-label required-field w-100 mb-3"
                                          ><input
                                          formControlName="trackingId"
                                          id="trackingId"
                                          type="text"
                                          pInputText
                                          /><label for="trackingId">TrackingId</label
                                          >@for (validation of validationMessages.trackingId; track validation) {
                                          <span
                                            >@if (
                                            (form1.get('trackingId').hasError(validation.type) &&
                                            form1.get('trackingId').dirty) ||
                                            form1.get('trackingId').touched) {
                                            <small
                                              class="p-invalid"
                                              >{{ validation.message }}</small
                                              >
                                              }</span
                                              >
                                              }</span
                                              >
                                            </div>

                                            <div class="col-lg-6">
                                              <span class="p-float-label required-field w-100 mb-3"
                                                ><input
                                                formControlName="opsNotes"
                                                id="opsNotes"
                                                type="text"
                                                pInputText
                                                /><label for="opsNotes">OpsNotes</label
                                                >@for (validation of validationMessages.opsNotes; track validation) {
                                                <span
                                                  >@if (
                                                  (form1.get('opsNotes').hasError(validation.type) &&
                                                  form1.get('opsNotes').dirty) ||
                                                  form1.get('opsNotes').touched) {
                                                  <small
                                                    class="p-invalid"
                                                    >{{ validation.message }}</small
                                                    >
                                                    }</span
                                                    >
                                                    }</span
                                                    >
                                                  </div>
                                                </div>
                                              </div>
                                              <hr />

                                              @if (msgCampaignId) {
                                                <div>
                                                  <h3>Filter Recipients</h3>
                                                  <p-checkbox class="ms-3 me-2 my-1" (onChange)="updateTableStatus('guest-profile',$event)" [formControl]="form1.controls['guestProfile']" inputId="guestProfile"
                                                  [binary]="true"></p-checkbox>
                                                  <label class="property-icon-wapper" for="guestProfile">Guest Profile</label>
                                                  <p-checkbox class="ms-3 me-2 my-1" (onChange)="updateTableStatus('guest-master-profile',$event)" [formControl]="form1.controls['guestMasterProfile']" inputId="guestMasterProfile"
                                                  [binary]="true"></p-checkbox>
                                                  <label class="property-icon-wapper" for="guestMasterProfile">Guest Master Profile</label>
                                                  <p-checkbox class="ms-3 me-2 my-1" (onChange)="updateTableStatus('owner-lead-profile',$event)" [formControl]="form1.controls['ownerLeadProfile']" inputId="ownerLeadProfile"
                                                  [binary]="true"></p-checkbox>
                                                  <label class="property-icon-wapper" for="ownerLeadProfile">Owner Lead Profile</label>
                                                  <p-checkbox class="ms-3 me-2 my-1" (onChange)="updateTableStatus('property-lead-profile',$event)" [formControl]="form1.controls['propertyLeadProfile']" inputId="propertyLeadProfile"
                                                  [binary]="true"></p-checkbox>
                                                  <label class="property-icon-wapper" for="propertyLeadProfile">Property Lead Profile</label>
                                                  <p-checkbox class="ms-3 me-2 my-1" (onChange)="updateTableStatus('employee-profile',$event)" [formControl]="form1.controls['employeeProfile']" inputId="employeeProfile"
                                                  [binary]="true"></p-checkbox>
                                                  <label class="property-icon-wapper" for="employeeProfile">Employee Profile</label>
                                                  <p-checkbox class="ms-3 me-2 my-1" (onChange)="updateTableStatus('owner-profile',$event)" [formControl]="form1.controls['ownerProfile']" inputId="ownerProfile"
                                                  [binary]="true"></p-checkbox>
                                                  <label class="property-icon-wapper" for="ownerProfile">Owner Profile</label>
                                                  <p-checkbox class="ms-3 me-2 my-1" (onChange)="updateTableStatus('realtor-profile',$event)" [formControl]="form1.controls['realtorProfile']" inputId="realtorProfile"
                                                  [binary]="true"></p-checkbox>
                                                  <label class="property-icon-wapper" for="realtorProfile">Realtor Profile</label>
                                                  <p-checkbox class="ms-3 me-2 my-1" (onChange)="updateTableStatus('contacts',$event)" [formControl]="form1.controls['contacts']" inputId="contacts"
                                                  [binary]="true"></p-checkbox>
                                                  <label class="property-icon-wapper" for="contacts">Contacts</label>
                                                  <p-checkbox class="ms-3 me-2 my-1" (onChange)="updateTableStatus('travel-agent-profile',$event)" [formControl]="form1.controls['travelAgentProfile']" inputId="travelAgentProfile"
                                                  [binary]="true"></p-checkbox>
                                                  <label class="property-icon-wapper" for="travelAgentProfile">Travel Agents</label>
                                                  <span *ngIf="form1.controls['travelAgentProfile'].value" class="ms-3">
                                                    <p-dropdown [options]="travelAgentPortalAccessOptions" formControlName="travelAgentPortalAccess"
                                                      optionLabel="label" optionValue="value" placeholder="All Agents">
                                                    </p-dropdown>
                                                  </span>
                                                  <div class="mt-2">
                                                    <app-search-template-msg searchLabel="Generate Msges" [showReservationId]="true" [showSearchButton]=true [parentScreen]="'msgcampaign'" [reset]=true [showLocations]=true [showDevelopments]=true
                                                      [showShortTermRentals]=true [showRateBuckets]=true  [showBedrooms]=true [showSeasons]=false [showSaleDateStart]=true [showSubjAdrCity] ="true"
                                                      [showSaleDateEnd]=true [showHoldDateStart]=true [showHoldDateEnd]=true [showHoldExpiredDateStart]=true [showHoldExpiredDateEnd]=true [showJobLevel]="true"
                                                      [showCheckInDateStart]=true [showCheckInDateEnd]=true [showCheckOutDateStart]=true [showCheckOutDateEnd]=true [showCancelDateStart]=true [showJobCategories]="true"
                                                      [guestMasterProfile]="guestMasterProfile" [ownerLeadProfile]="ownerLeadProfile" [propertyLeadProfile]="propertyLeadProfile" [showOwnerListingStatus]="true"
                                                      [employeeProfile]="employeeProfile" [showCurrentStayingGuests]="true" [ownerProfile]="ownerProfile" [guestProfile]="guestProfile" [showSubjAdrState]="true" [showSubAdrDevelopmentName]="true" [showSubAdrCity]="true"
                                                      [realtorProfile]="realtorProfile" [contacts]="contacts" [showSubAdrIsland]="true" [showOwnerLeadListingStatus]="true" [showCancelDateEnd]=true [showFutureGuestDate]=true
                                                    [showReservationStatus]=true [showExcludeFutureGuests]="true" [showExcludeUnsubscribers]="true" [showExcludeOwnerProfiles]="true" [parentId]="msgCampaignId" (doSearchCB)="onSearchSubmit($event)"></app-search-template-msg>
                                                  </div>
                                                </div>
                                              }
                                              @if (formLoading) {
                                                <div class="progress-spinner">
                                                  <app-spinner [formLoading]="formLoading"></app-spinner>
                                                </div>
                                              }

                                              @if (msgCampaignId) {
                                                <app-msg-list [msgCampaignId]="msgCampaignId" [listUpdated]="msgVOListUpdated" showFilter="showFilter" [isCompactList]="true"></app-msg-list>
                                              }
                                              <div class="row m-0">
                                                <div class="col-lg-12">
                                                  <div class="btn-group">
                                                    <div class="button-group">
                                                      @if (msgCampaignId) {
                                                        <button pButton class="btn-delete p-button-outlined p-button-danger"
                                                        (click)="onFormDelete()">Delete</button>
                                                      }
                                                      <button pButton class="btn-cancel p-button-text" (click)="sendutBoxOMsgs()">Send Outbox</button>
                                                    </div>

                                                    <div class="button-group">
                                                      <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
                                                      @if (msgCampaignId) {
                                                        <button pButton  class="btn-upt p-button" (click)="onClearDrafts()">Clear Drafts</button>
                                                      }
                                                      @if (!msgCampaignId) {
                                                        <button pButton class="btn-addt p-button" (click)="formAdd()">Add</button>
                                                      }
                                                      @if (msgCampaignId) {
                                                        <button pButton  class="btn-upt p-button" (click)="formUpdate()">Update</button>
                                                      }
                                                      @if (msgCampaignId) {
                                                        <button pButton  class="btn-upt p-button" (click)="sendMsg()">Send</button>
                                                      }
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
